import Lozenge from '@atlaskit/lozenge';
import { ProductKey, PRODUCT_ICON_BY_KEY } from '../../../models';
import {
  containerStyle,
  lozengeStyle,
  mainContentStyle,
  productNameStyle,
  productTextStyle,
  siteNameStyle,
  subContentStyle,
  totalCostStyle,
  userBreakdownStyle
} from './entitlement-item.styles';

export interface EntitlementItemProps {
  daysLeft?: number;
  productKey: ProductKey;
  productAndPlanName: string;
  siteName: string;
  formattedTotalPrice: string;
  usersPriceBreakdown: string;
}

const EntitlementItem = ({
  daysLeft,
  productKey,
  productAndPlanName,
  siteName,
  formattedTotalPrice,
  usersPriceBreakdown
}: EntitlementItemProps) => {
  const IconComponent = PRODUCT_ICON_BY_KEY[productKey];

  const pluralize = (count: number) => (count === 1 ? '' : 's');

  return (
    <div css={containerStyle}>
      <Lozenge appearance={daysLeft ? 'default' : 'removed'}>
        {daysLeft ? (
          <span css={lozengeStyle}>
            {daysLeft} day{pluralize(daysLeft)} left in trial
          </span>
        ) : (
          <span css={lozengeStyle}>URGENT ACTION NEEDED</span>
        )}
      </Lozenge>
      <div css={mainContentStyle}>
        <div css={productTextStyle}>
          <IconComponent appearance="brand" size="small" />
          <div css={productNameStyle}>{productAndPlanName}</div>
        </div>
        <div css={totalCostStyle}>{formattedTotalPrice}</div>
      </div>
      <div css={subContentStyle}>
        <div css={siteNameStyle}>{siteName}</div>
        <div css={userBreakdownStyle}>{usersPriceBreakdown}</div>
      </div>
    </div>
  );
};

export { EntitlementItem };
